import {HotkeyConfiguration} from '@accurate-player/accurate-player-plugins';

export enum HotkeyGroup {
    Playback = 'Adjust Playback',
    Step = 'Step',
    Seek = 'Seek',
    Volume = 'Adjust Volume',
    AddItem = 'Add Item',
    EditSelected = 'Edit Selected Item',
    SelectRange = 'Select Range',
    Others = 'Others',
}

export interface HotkeyGroupType {
    [key: string]: {
        key: string;
        title?: string;
    }[];
}

export const HOTKEY_GROUPS = {
    [HotkeyGroup.Playback]: [
        {
            key: 'p',
        },
        {
            key: 'cmd+k',
        },
        {
            key: 'space',
        },
        {
            key: 'j',
        },
        {
            key: 'k',
        },
        {
            key: 'l',
        },
        // {
        //     key: 'r',
        // },
    ],
    [HotkeyGroup.Step]: [
        {
            key: 'left',
            title: '1 frame backward',
        },
        {
            key: 'right',
            title: '1 frame forward',
        },
        {
            key: 'shift+left',
            title: '10 frames backward',
        },
        {
            key: 'shift+right',
            title: '10 frames forward',
        },
        {
            key: 'shift+down',
            title: '1 second backward',
        },
        {
            key: 'shift+up',
            title: '1 second forward',
        },
        {
            key: 'ctrl+shift+down',
            title: '5 seconds backward',
        },
        {
            key: 'ctrl+shift+up',
            title: '5 seconds forward',
        },
        // {
        //     key: 'ctrl+down',
        //     title: '10 seconds backward',
        // },
        // {
        //     key: 'ctrl+up',
        //     title: '10 seconds forward',
        // },
        {
            key: 'alt+down',
            title: '1 minute backward',
        },
        {
            key: 'alt+up',
            title: '1 minute forward',
        },
        {
            key: 'pagedown',
            title: '10 minute backward',
        },
        {
            key: 'pageup',
            title: '10 minute forward',
        },
    ],
    [HotkeyGroup.Seek]: [
        {
            key: 'home, 0',
            title: 'To start of media',
        },
        {
            key: '1',
            title: 'To 10 percent of media',
        },
        {
            key: '2',
            title: 'To 20 percent of media',
        },
        {
            key: '3',
            title: 'To 30 percent of media',
        },
        {
            key: '4',
            title: 'To 40 percent of media',
        },
        {
            key: '5',
            title: 'To 50 percent of media',
        },
        {
            key: '6',
            title: 'To 60 percent of media',
        },
        {
            key: '7',
            title: 'To 70 percent of media',
        },
        {
            key: '8',
            title: 'To 80 percent of media',
        },
        {
            key: '9',
            title: 'To 90 percent of media',
        },
        {
            key: 'end, ctrl+0',
            title: 'To end of media',
        },
    ],
    [HotkeyGroup.Volume]: [
        {
            key: 'm',
        },
        {
            key: 'down',
        },
        {
            key: 'up',
        },
    ],
    [HotkeyGroup.AddItem]: [
        {
            key: 'c',
        },
        {
            key: 'v',
        },
        {
            key: 'b',
        },
        {
            key: 'n',
        },
    ],
    [HotkeyGroup.EditSelected]: [
        {
            key: 's',
        },
        {
            key: 'e',
        },
        {
            key: 'shift+s',
        },
        {
            key: 'shift+e',
        },
        {
            key: 'ctrl+shift+c',
        },
        {
            key: 'shift+c',
        },
        {
            key: 'esc',
        },
    ],
    [HotkeyGroup.SelectRange]: [
        {
            key: 'i',
            title: 'Set selection In',
        },
        {
            key: 'o',
            title: 'Set selection Out',
        },
        {
            key: 'shift+i',
            title: 'Go to selection In',
        },
        {
            key: 'shift+o',
            title: 'Go to selection Out',
        },
        {
            key: 'cmd+shift+x',
            title: 'Clear selection',
        },
        {
            key: 'cmd+shift+i',
            title: 'Clear selection In',
        },
        {
            key: 'cmd+shift+o',
            title: 'Clear selection Out',
        },
    ],
    [HotkeyGroup.Others]: [
        {
            key: 'esc',
            title: 'Close popup',
        },
        {
            key: 'f',
        },
        {
            key: 'd',
            title: 'Disable all subtitle tracks',
        },
        {
            key: 'shift+/',
        },
    ],
};

export interface HotkeyConfigurationType {
    keyCombo: string[];
    description: string;
}

export interface HotkeyConfigurationGroup extends HotkeyConfigurationType {
    group: HotkeyGroup;
}

export const hotkeyDescriptionMapping = new Map<string, string>([
    ['i', 'Set selection in'],
    ['o', 'Set selection out'],
    ['shift+i', 'Go to selection in'],
    ['shift+o', 'Go to selection out'],
    ['d', 'Disable all subtitle tracks'],
    ['ctrl+shift+x', 'Clear both selection in and out'],
    ['ctrl+shift+i', 'Clear selection in'],
    ['ctrl+shift+o', 'Clear selection out'],
]);

export interface HotKeyGroupsList {
    [key: string]: HotkeyConfiguration;
}

export type GroupKeyType<U> = {key: U; title: string};
